// extracted by mini-css-extract-plugin
module.exports = {"product-card":"method_product-card__wWnCk","method":"method_method__EFzn9","secondary":"method_secondary__3OKs_","primary":"method_primary__6GWBn"};